export default __webpack_public_path__ + "static/media/O-114.813e4224.png";